// =========== plugin import ========= //
import {useState, useEffect, useRef} from 'react'
import Swal from 'sweetalert2';
import axios from 'axios'
// ========= component import ========= //
import AddAttribute from './component/AddAttribute';
import AttributeList from './component/AttributeList';
import AttributeUpdateDrawer from './component/AttributeUpdateDrawer';
import SideDrawer from '../../../../../../../../component/common/SideDrawer';

const AttributeSetup = (props) => {

    const api_base_url = process.env.REACT_APP_API_URL;
    const loginUserType = localStorage.getItem('type');
    const {formData, formValidateError} = props;

    // --------- define all state ------ //
    const [ attributeUpdateId , setAttributeUpdateId ] = useState(-1);
    const [ viewAttributeList , setViewAttributeList ] = useState([]);
    const [ attributeUpdateDrawerIsOpen, setAttributeUpdateDrawerIsOpen] = useState(false);
    const [ updateAttributeState, setUpdateAttributeState ] = useState([]);
    const [attributeStateIsChange, setAttributeStateIsChange] = useState(false);

    const attributeFormSaveHandler = async (attributeData) => {
        if(Object.keys(attributeData).length > 0){
            setAttributeStateIsChange(true)

            // if(attributeData.entities !== ''){
            //     attributeData.entities = JSON.parse(attributeData.entities)
            // }
            // else{
            //     attributeData.entities = []
            // }

            // if(attributeData.list_item !== ''){
            //     attributeData.list_item = JSON.parse(attributeData.list_item)
            // }
            // else{
            //     attributeData.list_item = []
            // }


            let isDuplicate = false;
            if(formData['step4']?.attribute_setup?.attribute !== ''){
                isDuplicate = formData['step4'].attribute_setup.some(
                    (attributes) => attributes.attribute.trim() === attributeData.attribute.trim()
                );
            }
            if(attributeUpdateId < 0){
                // ---- insert ---- //
                if (isDuplicate) {
                    await Swal.fire({
                        text: 'Duplicate attribute cannot be added !',
                        icon: 'error',
                        showCancelButton: true,
                        showConfirmButton : false,
                        cancelButtonText: 'OK',
                    });
                    return;
                }

                if(attributeData.entities !== ''){
                    attributeData.entities = JSON.parse(attributeData.entities)
                }
                else{
                    attributeData.entities = []
                }
                if(attributeData.list_item !== ''){
                    attributeData.list_item = JSON.parse(attributeData.list_item)
                }
                else{
                    attributeData.list_item = []
                }

                setViewAttributeList((prevList) => [...prevList, attributeData]); 
                props.onInputChange(
                    'step4',
                    'attribute_setup',
                    [
                        ...(Array.isArray(formData['step4'].attribute_setup) ? formData['step4'].attribute_setup : []),
                        attributeData
                    ]
                );
            }
            else{
                // ----- update ---- //
                const updatedAttributeState = [...formData['step4'].attribute_setup];
                if(updatedAttributeState[attributeUpdateId].attribute !== attributeData.attribute){
                    if (isDuplicate) {
                        await Swal.fire({
                            text: 'Duplicate feature name cannot be added !',
                            icon: 'error',
                            showCancelButton: true,
                            showConfirmButton : false,
                            cancelButtonText: 'OK',
                        });
                        return;
                    }
                }

                if(attributeData.entities !== ''){
                    attributeData.entities = JSON.parse(attributeData.entities)
                }
                else{
                    attributeData.entities = []
                }
                if(attributeData.list_item !== ''){
                    attributeData.list_item = JSON.parse(attributeData.list_item)
                }
                else{
                    attributeData.list_item = []
                }

                let old_attribute_name = updatedAttributeState[attributeUpdateId].attribute;
                let new_attribute_name = attributeData.attribute;
                // ------ update service_attributes_association ------ //
                const saAssociation = formData['step4'].service_attributes_association;
                if(Object.keys(saAssociation).length > 0){
                    props.productFeatureAssociationApiCall(true)
                    const updatedState = Object.fromEntries(
                        Object.entries(saAssociation).map(([key, arr]) => [
                            key,
                            {
                                ...arr,
                                attribute_list: arr.attribute_list.map(obj =>
                                    obj.label === old_attribute_name
                                        ? { ...obj, label: new_attribute_name, value: new_attribute_name }
                                        : obj
                                )
                            }
                        ])
                    );
                    props.onInputChange('step4', 'service_attributes_association', updatedState);
                }
                // ----- update service_attributes_association_setup ------ //
                const saAssSetup = formData['step4'].service_attributes_association_setup
                if( saAssSetup.length > 0 ){
                    props.serviceAttributeAssSetupApiCall(true)
                    var needArr = saAssSetup.map((item) => {
                        return {
                            ...item,
                            service_attribute_association: item.service_attribute_association.map((assoc) => {
                                return {
                                    label: assoc.label.includes(`Attribute: ${old_attribute_name}`)
                                        ? assoc.label.replace(`Attribute: ${old_attribute_name}`, `Attribute: ${new_attribute_name}`)
                                        : assoc.label,
                                    value: assoc.value.includes(`Attribute: ${old_attribute_name}`)
                                        ? assoc.value.replace(`Attribute: ${old_attribute_name}`, `Attribute: ${new_attribute_name}`)
                                        : assoc.value,
                                };
                            }),
                        };
                    });
                    props.onInputChange('step4', 'service_attributes_association_setup', needArr);
                }
                // -------- update attribute_setup ------ //
                if(attributeData.data_type){
                    if(attributeData.data_type.value === 'Alphanumeric'){
                        attributeData.min_nonNegativeInteger = '';
                        attributeData.max_nonNegativeInteger = '';
                        attributeData.max_integer = '';
                        attributeData.min_integer = '';
                        attributeData.min_float = '';
                        attributeData.max_float = '';
                        attributeData.time_start_date = '';
                        attributeData.time_end_date = '';
                        attributeData.min_string = '';
                        attributeData.max_string = '';
                        attributeData.min_currency = '';
                        attributeData.max_currency = '';
                        attributeData.money_currency = null;
                        attributeData.select_boolean = null;
                        attributeData.list_item = '';
                    }
                    else if(attributeData.data_type.value === 'Boolean'){
                        attributeData.min_alphanumeric = '';
                        attributeData.max_alphanumeric = '';
                        attributeData.min_nonNegativeInteger = '';
                        attributeData.max_nonNegativeInteger = '';
                        attributeData.max_integer = '';
                        attributeData.min_integer = '';
                        attributeData.min_float = '';
                        attributeData.max_float = '';
                        attributeData.time_start_date = '';
                        attributeData.time_end_date = '';
                        attributeData.min_string = '';
                        attributeData.max_string = '';
                        attributeData.min_currency = '';
                        attributeData.max_currency = '';
                        attributeData.money_currency = null;
                        attributeData.list_item = '';
                    }
                    else if(attributeData.data_type.value === 'Currency'){
                        attributeData.min_alphanumeric = '';
                        attributeData.max_alphanumeric = '';
                        attributeData.min_nonNegativeInteger = '';
                        attributeData.max_nonNegativeInteger = '';
                        attributeData.max_integer = '';
                        attributeData.min_integer = '';
                        attributeData.min_float = '';
                        attributeData.max_float = '';
                        attributeData.time_start_date = '';
                        attributeData.time_end_date = '';
                        attributeData.min_string = '';
                        attributeData.max_string = '';
                        attributeData.select_boolean = null;
                        attributeData.list_item = '';
                    }
                    else if(attributeData.data_type.value === 'dateTime'){
                        attributeData.min_alphanumeric = '';
                        attributeData.max_alphanumeric = '';
                        attributeData.min_nonNegativeInteger = '';
                        attributeData.max_nonNegativeInteger = '';
                        attributeData.max_integer = '';
                        attributeData.min_integer = '';
                        attributeData.min_float = '';
                        attributeData.max_float = '';
                        attributeData.min_string = '';
                        attributeData.max_string = '';
                        attributeData.select_boolean = null;
                        attributeData.min_currency = '';
                        attributeData.max_currency = '';
                        attributeData.money_currency = null;
                        attributeData.list_item = '';
                    }
                    else if(attributeData.data_type.value === 'Float'){
                        attributeData.min_alphanumeric = '';
                        attributeData.max_alphanumeric = '';
                        attributeData.min_nonNegativeInteger = '';
                        attributeData.max_nonNegativeInteger = '';
                        attributeData.max_integer = '';
                        attributeData.min_integer = '';
                        attributeData.min_string = '';
                        attributeData.max_string = '';
                        attributeData.select_boolean = null;
                        attributeData.min_currency = '';
                        attributeData.max_currency = '';
                        attributeData.money_currency = null;
                        attributeData.time_start_date = '';
                        attributeData.time_end_date = '';
                        attributeData.list_item = '';
                    }
                    else if(attributeData.data_type.value === 'Integer'){
                        attributeData.min_nonNegativeInteger = '';
                        attributeData.max_nonNegativeInteger = '';
                        attributeData.min_alphanumeric = '';
                        attributeData.max_alphanumeric = '';
                        attributeData.min_string = '';
                        attributeData.max_string = '';
                        attributeData.select_boolean = null;
                        attributeData.min_currency = '';
                        attributeData.max_currency = '';
                        attributeData.money_currency = null;
                        attributeData.time_start_date = '';
                        attributeData.time_end_date = '';
                        attributeData.min_float = '';
                        attributeData.max_float = '';
                        attributeData.list_item = '';
                    }
                    else if(attributeData.data_type.value === 'nonNegativeInteger'){
                        attributeData.min_alphanumeric = '';
                        attributeData.max_alphanumeric = '';
                        attributeData.min_string = '';
                        attributeData.max_string = '';
                        attributeData.select_boolean = null;
                        attributeData.min_currency = '';
                        attributeData.max_currency = '';
                        attributeData.money_currency = null;
                        attributeData.time_start_date = '';
                        attributeData.time_end_date = '';
                        attributeData.min_float = '';
                        attributeData.max_float = '';
                        attributeData.max_integer = '';
                        attributeData.min_integer = '';
                        attributeData.list_item = '';
                    }
                    else if(attributeData.data_type.value === 'String'){
                        attributeData.min_alphanumeric = '';
                        attributeData.max_alphanumeric = '';
                        attributeData.select_boolean = null;
                        attributeData.min_currency = '';
                        attributeData.max_currency = '';
                        attributeData.money_currency = null;
                        attributeData.time_start_date = '';
                        attributeData.time_end_date = '';
                        attributeData.min_float = '';
                        attributeData.max_float = '';
                        attributeData.min_nonNegativeInteger = '';
                        attributeData.max_nonNegativeInteger = '';
                        attributeData.max_integer = '';
                        attributeData.min_integer = '';
                        attributeData.list_item = '';
                    }
                    else if(attributeData.data_type.value === 'List'){
                        attributeData.min_nonNegativeInteger = '';
                        attributeData.max_nonNegativeInteger = '';
                        attributeData.max_integer = '';
                        attributeData.min_integer = '';
                        attributeData.min_float = '';
                        attributeData.max_float = '';
                        attributeData.time_start_date = '';
                        attributeData.time_end_date = '';
                        attributeData.min_string = '';
                        attributeData.max_string = '';
                        attributeData.min_currency = '';
                        attributeData.max_currency = '';
                        attributeData.money_currency = null;
                        attributeData.select_boolean = null;
                        attributeData.min_alphanumeric = '';
                        attributeData.max_alphanumeric = '';
                    }
                }
                else{
                    attributeData.min_nonNegativeInteger = '';
                    attributeData.max_nonNegativeInteger = '';
                    attributeData.max_integer = '';
                    attributeData.min_integer = '';
                    attributeData.min_float = '';
                    attributeData.max_float = '';
                    attributeData.time_start_date = '';
                    attributeData.time_end_date = '';
                    attributeData.min_string = '';
                    attributeData.max_string = '';
                    attributeData.min_currency = '';
                    attributeData.max_currency = '';
                    attributeData.money_currency = null;
                    attributeData.select_boolean = null;
                    attributeData.min_alphanumeric = '';
                    attributeData.max_alphanumeric = '';
                    attributeData.list_item = '';
                }
                updatedAttributeState[attributeUpdateId] = attributeData;
                setViewAttributeList(updatedAttributeState);
                props.onInputChange(
                    'step4',
                    'attribute_setup',
                    updatedAttributeState
                );
                setAttributeUpdateDrawerIsOpen(false)
            }
            setAttributeUpdateId(-1)
        }
    }

    const attributeUpdateOnClickHandler = (index) => {
        setUpdateAttributeState([viewAttributeList[index]])
        setAttributeUpdateId(index)
        setAttributeUpdateDrawerIsOpen(true)
    }
    const attributeDeleteOnClickHandler = (index) => {
        setAttributeStateIsChange(true)
        const updateAttributesList = [...viewAttributeList];
        const deleteAttributeName = updateAttributesList[index].attribute;

        // ------- delete service_attributes_association ------- //
        let saAssociation = formData['step4'].service_attributes_association;
        if( Object.keys(saAssociation).length > 0 ){
            props.productFeatureAssociationApiCall(true)
            let updatedData = {};
            Object.keys(saAssociation).forEach((attribute) => {
                const updateAttributeList = saAssociation[attribute].attribute_list.filter(
                    (attribute) => attribute.value !== deleteAttributeName
                );
                if (updateAttributeList.length > 0) {
                    updatedData[attribute] = {
                        ...saAssociation[attribute], 
                        attribute_list: updateAttributeList 
                    };
                }
            });
            props.onInputChange('step4', 'service_attributes_association', updatedData);
        }

        // ----- delete service_attributes_association_setup ------- //
        let saAssociationSetup = formData['step4'].service_attributes_association_setup;
        if( saAssociationSetup.length > 0 ){
            props.serviceAttributeAssSetupApiCall(true)
            const filterServiceData = (data, attributeToRemove) => {
                return data
                .map((item) => ({
                ...item,
                service_attribute_association: item.service_attribute_association.filter(
                    (assoc) => !assoc.value.includes(`Attribute: ${attributeToRemove}`)
                ),
                }))
                .filter((item) => item.service_attribute_association.length > 0);
            };
            const saAssDataUpdate =  filterServiceData(saAssociationSetup, deleteAttributeName);
            props.onInputChange('step4', 'service_attributes_association_setup', saAssDataUpdate);
        }

        // ------- delete attribute_setup -------- //
        updateAttributesList.splice(index, 1);
        setViewAttributeList(updateAttributesList);
        props.onInputChange(
            'step4',
            'attribute_setup',
            updateAttributesList
        );
    }
    const attributeListOnDropHandler = (rearrangeAttributeData) => {
        setAttributeStateIsChange(true)
        setViewAttributeList(rearrangeAttributeData);
        props.onInputChange(
            'step4',
            'attribute_setup',
            rearrangeAttributeData
        );
    }

    const drawerOnCloseHandler = (drawerName) => {
        const drawerMap = {
            attribute_update_drawer: () => {
                setAttributeUpdateDrawerIsOpen(false)
                setAttributeUpdateId(-1)
            },
        };
        if (drawerMap[drawerName]) {
            drawerMap[drawerName]();
        }
    }

    useEffect(() => {
        setAttributeStateIsChange(false)
        setViewAttributeList(formData['step4'].attribute_setup);
    },[formData['step4']])

    // ------- attribute_setup api call --------- //
    const attributeSetupFormRef = useRef(); 
    useEffect(() => {
        const saveAttributeDetails = async () => {
            if(!attributeStateIsChange) return
            const saveAttributeData = async () => {
                let attributeData = [];
                if(viewAttributeList.length > 0){
                    const indexAttribute = viewAttributeList.map((attribute, index) => ({
                        ...attribute,
                        index,
                    }));
                    attributeData = indexAttribute;
                }
                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token')
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken')
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }

                let attributeFormData = new FormData();
                attributeFormData.append("action_type", 'attribute_setup');
                attributeFormData.append("bot_id", formData.bot_id);
                attributeFormData.append("step", "step4");
                attributeFormData.append("data", JSON.stringify(attributeData));
                attributeFormData.append("sass_id", localStorage.getItem('sass_id'));
                attributeFormData.append("user_type", localStorage.getItem('type'));
                attributeFormData.append("user_name", loginUserType == 'SA' ? localStorage.getItem('system_username') : '');
                const apiHeaders = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "x-access-token": apiToken,
                    },
                };
                try {
                    await axios.post(`${api_base_url}api/save-bot-details`, attributeFormData, apiHeaders)
                    .then(async (res) => {
                        if(res.data.status === 'success'){
                            attributeFormData = new FormData();
                            setAttributeStateIsChange(false)
                            attributeSetupFormRef.current?.resetForm();
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                } catch (error) {
                    console.error("Error during save:", error);
                }
            }
            await saveAttributeData();
        }
        saveAttributeDetails()
    },[viewAttributeList])

    return (
        <>
            <div className="row mb-5 border border-dashed border-gray-400 rounded p-5">
                <a className="fw-bold text-gray-800 mb-2 fs-3">
                    Attribute Setup
                </a>
                <div className='col-md-12'>
                    <AddAttribute
                        formValidateError={formValidateError}
                        attributeFormSave={attributeFormSaveHandler}
                        updateAttributeState={updateAttributeState}
                        isInfoOpenHandler={props.isInfoOpenHandler}
                        ref={attributeSetupFormRef}
                    />
                </div>
                <div className='col-md-12'>
                    <AttributeList
                        viewAttributeList = {viewAttributeList}
                        attributeUpdateOnClick={attributeUpdateOnClickHandler}
                        attributeDeleteOnClick={attributeDeleteOnClickHandler}
                        attributeListOnDrop={attributeListOnDropHandler}
                    />
                </div>
            </div>
             <SideDrawer
                title={'Attribute Data Update'}
                width={600}
                open={attributeUpdateDrawerIsOpen}
                drawer_name={'attribute_update_drawer'}
                placement={'right'}
                closable={false}
                drawerOnClose={drawerOnCloseHandler}
            >
                <AttributeUpdateDrawer
                    formValidateError={formValidateError}
                    attributeFormSave={attributeFormSaveHandler}
                    updateAttributeState={updateAttributeState}
                    ref={attributeSetupFormRef}
                />
            </SideDrawer>
        </>
    )
}

export default AttributeSetup
